<template> 
  <div class="error">
    <img src="@assets/img/error/404.png"> 
  </div>

</template>

<script>

export default {
  name: 'error404', 
}

</script>

<style scoped lang='scss'>
.error {
  text-align: center;
  padding-top: 20%;
  p{
    margin-top: 40px;
  }
  img {
    max-width: 100%;
  }
  .txt, a { color: #1890ff; }
}
</style> 